import React from 'react'
import { FaRegCircle, FaRegDotCircle } from 'react-icons/fa'
import { Box, Modal, Typography } from '@mui/material'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'
import { BiX } from 'react-icons/bi'

import { stMob } from '../styles'

export default function ModalFiltro({ modal, onClosed, type }) {
  const { sttCtxAgend, actionsAgend } = React.useContext(AgendamentoContext)

  const array =
    type === 'tipo' ? ['Avulsos', 'Fixos', 'Todos'] : ['Solicitados', 'Agendados', 'Realizados', 'Cancelados', 'Todos']

  return (
    <Modal open={modal} onClose={onClosed} sx={stMob.containModal}>
      <Box sx={stMob.containModalContent}>
        <Box sx={stMob.containTitleModal}>
          <Typography variant='h6' sx={stMob.titleModal}>
            {type === 'tipo' ? 'Selecione o tipo' : 'Selecione a situação'}
          </Typography>
          <BiX style={stMob.iconClose} onClick={onClosed} />
        </Box>
        <Box sx={stMob.containListButtons}>
          {array.map((item, index) => (
            <Box
              key={index}
              sx={stMob.containSelect}
              onClick={() => {
                actionsAgend.handleSttCtxAgend(type === 'tipo' ? 'avulsoSel' : 'typePed', item)
                onClosed()
              }}
            >
              {sttCtxAgend[type === 'tipo' ? 'avulsoSel' : 'typePed'] === item ? (
                <FaRegDotCircle style={stMob.iconCircleSel} />
              ) : (
                <FaRegCircle style={stMob.iconCircle} />
              )}
              <Typography sx={stMob.textButton}>{item}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Modal>
  )
}
